<h6 class="form-header h6-icon">
  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.ADDRESS' | translate }}
</h6>

<div class="form-group" [formGroup]="Address">
  <div class="row">
    <div class="form-group col-5">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.POSTALCODE' | translate }}@if (Address.get('PostalCode').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="PostalCode" (change)="checkPostalCode(false)" formControlName="PostalCode">
      <t4-display-validation controlName="PostalCode" [form]="Address" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="form-group col-3">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.STREETNR' | translate }}@if (Address.get('StreetNr').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="StreetNr" (change)="checkPostalCode(false)" formControlName="StreetNr">
      <t4-display-validation controlName="StreetNr" [form]="Address" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.STREETADDITION' | translate }}@if (Address.get('StreetNrAddition').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="streetNrAddition" (change)="checkPostalCode(false)" formControlName="StreetNrAddition">
    </div>
  </div>

  <div class="row">
    <div class="form-group col-12">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.STREET' | translate }}@if (Address.get('Street').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="street" formControlName="Street">
      <t4-display-validation controlName="Street" [form]="Address" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-6">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.CITY' | translate }} @if (Address.get('City').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="city" formControlName="City">
      <t4-display-validation controlName="City" [form]="Address" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="form-group col-6">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.COUNTRY' | translate }}@if (Address.get('CountryId').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <ng-select [items]="countries" bindLabel="Name" bindValue="Id" formControlName="CountryId"
        placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.COUNTRY' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
        <!-- Selected item -->
        <ng-template ng-label-tmp let-item="item">
          {{ item.Iso2 ? (('COUNTRY.'+item.Iso2) | translate) : ""}}
        </ng-template>
        <!-- Dropdown items -->
        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          {{('COUNTRY.'+item.Iso2) | translate}}
        </ng-template>
      </ng-select>
      <t4-display-validation controlName="CountryId" [form]="Address" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>
</div>
